export default __webpack_public_path__ + "static/char-s-53-zh-Hant-c32c55d0e4be2407b6f890b3edad2423.webp";